package kz.dentalcrm.app.core.network

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.ClientRequestException
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.request
import io.ktor.client.statement.bodyAsText
import io.ktor.http.isSuccess
import  kz.dentalcrm.app.core.utils.Result

sealed class ErrorContent {
    abstract val title: String?
    abstract val message: String?
    abstract val code: String?

    data class Validation(
        val content: HashMap<String, String>?,
        override val code: String?,
        override val title: String?,
        override val message: String?
    ): ErrorContent()

    data class Dead(
        val statusCode: Int? = null,
        override val code: String? = null,
        override val title: String?,
        override val message: String?
    ): ErrorContent()

    data class Alert(
        val statusCode: Int? = null,
        override val code: String?,
        override val title: String?,
        override val message: String?
    ): ErrorContent()
}

suspend inline fun <reified Data> HttpClient.handle(
    block: HttpRequestBuilder.() -> Unit
): Result<Data> = try {
    val response = request(block)

    if (response.status.isSuccess()) {
        Result.Success(response.body())
    } else {
        Result.Failure(Throwable("${response.status}: ${response.bodyAsText()}"))
    }
} catch (ex: Exception) {
    when (ex) {
        is ClientRequestException -> {
            if (ex.response.status.value == 401) UnauthorizedEventBus.emit()
            Result.Error(ex.response.status.value, ex.message)
        }
        else -> {
            Result.Failure(ex)
        }
    }
}

suspend inline fun <reified Data, reified Domain> HttpClient.handleWithResult(
    mapping: (Data?) -> Domain,
    block: HttpRequestBuilder.() -> Unit
): Result<Domain> = try {
    val response = request(block)

    if (response.status.isSuccess()) {
        Result.Success(mapping(response.body()))
    } else {
        Result.Failure(Throwable("${response.status}: ${response.bodyAsText()}"))
    }
} catch (ex: Exception) {
    when (ex) {
        is ClientRequestException -> {
            if (ex.response.status.value == 401) UnauthorizedEventBus.emit()
            Result.Error(ex.response.status.value, ex.message)
        }
        else -> {
            Result.Failure(ex)
        }
    }
}